<div class="content">
  <div fxLayout="row wrap" fxLayoutGap="16px grid" class="elec_list">
    <div class="title">
      <img class="timg-icon" src="assets/images/barracks/1.png" alt="" />
    </div>
    <div style="width: 100%">
      <h1>
        வரவேற்கிறோம் : <span class="name">{{ parameters?.name }}</span>
      </h1>
    </div>
    <div
      fxFlex="50%"
      fxFlex.xs="100%"
      fxFlex.sm="50%"
      *ngFor="let elect of parameters?.elections"
      (click)="selectElection(elect)"
    >
      <mat-card style="cursor: pointer" class="mat-elevation-z4 text list">
        <mat-card-header>
          <mat-card-title>{{ elect.election_name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>பிறப்பொக்கும் எல்லா உயிர்க்கும்</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
